export enum PostPageNameEnum {
    stories = "stories",
    news = "news",
}
